import type { BaseComponent } from '@libs/ui/ds/lib/internals'
import { outlineFocusMixin } from '@libs/ui/ds/lib/styles/mixins/mixins'
import { UnstyledButton } from '@mantine/core'
import { cva } from 'class-variance-authority'
import type { FC, HTMLAttributes, PropsWithChildren, RefObject } from 'react'

const topNavbarItemCVA = cva(
  [
    'flex h-9 items-center rounded p-2 text-s text-neutral-100',
    outlineFocusMixin
  ],
  {
    variants: {
      active: {
        true: 'bg-neutral-700 hover:bg-neutral-600/75 active:bg-neutral-600',
        false: 'hover:bg-neutral-700 active:bg-neutral-600'
      }
    }
  }
)

type Props = BaseComponent &
  PropsWithChildren &
  HTMLAttributes<HTMLButtonElement> & {
    active?: boolean
    ref?: RefObject<HTMLButtonElement>
  }

export const TopNavbarItem: FC<Props> = ({
  className,
  active = false,
  children,
  onClick,
  ref,
  ...other
}) => {
  return (
    <UnstyledButton
      ref={ref}
      role='button'
      tabIndex={0}
      onClick={onClick}
      className={topNavbarItemCVA({ className, active })}
      {...other}
    >
      {children}
    </UnstyledButton>
  )
}
